import * as React from 'react';
import { BaseSvg, SVGIconProps } from './BaseSvg';

export const AccessTime: React.FC<SVGIconProps> = ({ size = 14, color = '#262E3F', ...props }) => (
  <BaseSvg width={size} height={Math.round(size * (20 / 21))} viewBox="0 0 21 20" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5 10C0.5 4.48 4.97 0 10.49 0C16.02 0 20.5 4.48 20.5 10C20.5 15.52 16.02 20 10.49 20C4.97 20 0.5 15.52 0.5 10ZM2.5 10C2.5 14.42 6.08 18 10.5 18C14.92 18 18.5 14.42 18.5 10C18.5 5.58 14.92 2 10.5 2C6.08 2 2.5 5.58 2.5 10ZM9.5 5H11V10.25L15.5 12.92L14.75 14.15L9.5 11V5Z"
      fill={color}
    />
  </BaseSvg>
);
